// import { Typography } from "@mui/material";
import React, { useState } from "react";
import { DataService } from "../../auth/DataService";
import { backend_url } from "../../auth/setting";

const TestPageDev2 = (props) => {
  const [count, setCount] = useState(0);

  //   let host = "http://localhost:8080";
  let host = backend_url;

  async function GetVesselReports() {
    setCount(count + 1);

    let url = host + "/vessel/vesselReports";
    // let authHeader = await DataService.getAuthorizationHeader();

    // const headers = {
    //   "Content-Type": "application/json",
    //   Authorization: authHeader,
    // };

    const headers = DataService.getFetchHeader();

    let vesselReports = await DataService.fetchGet(url, headers);

    console.log("vesselReports: " + JSON.stringify(vesselReports));
  }

  async function GetMemoryParams() {
    setCount(count + 1);

    await DataService.GetMemoryParams();
  }

  async function readTokenEntries() {
    setCount(count + 1);

    DataService.readTokenEntries();
  }

  async function getCookies() {
    setCount(count + 1);

    console.log("cookies: --------------------------------------------");
    const cookieList = document.cookie ? document.cookie.split(";") : [];

    const cookieValues = {};
    for (let i = 0, n = cookieList.length; i != n; ++i) {
      const cookie = cookieList[i];
      const f = cookie.indexOf("=");
      if (f >= 0) {
        const cookieName = cookie.substring(0, f);
        const cookieValue = cookie.substring(f + 1);
        console.log(`cookieName ${cookieName} – cookieValue ${cookieValue}`);
        if (!cookieValues.hasOwnProperty(cookieName)) {
          cookieValues[cookieName] = cookieValue;
        }
      }
    }
  }

  return (
    <div>
      <h2>Test enviroment</h2>
      <button onClick={GetVesselReports}>Fetch GetReports</button>
      <br />
      <br />
      <button onClick={GetMemoryParams}>read Memory</button>
      <br />
      <br />
      <button onClick={readTokenEntries}>read Token</button>
      <br />
      <br />
      <button onClick={getCookies}>getCookies</button>
    </div>
  );
};

export { TestPageDev2 };
